// El perfil del usuario no se pudo leer. No es lo mismo que no tener acceso: acusar a la cuenta de
// un problema de red manda al vendedor a pedir permisos que ya tiene.
import { WifiOff } from 'lucide-react';

export function PortalProfileUnavailable({ onRetry }: { onRetry: () => void }) {
    return (
        <div
            role="alert"
            className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center"
        >
            <span className="flex size-12 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
                <WifiOff className="size-6" aria-hidden />
            </span>
            <h1 className="text-lg font-semibold text-foreground">No se pudo leer tu perfil</h1>
            <p className="max-w-md text-sm leading-relaxed text-muted-foreground">
                No pudimos consultar tus permisos. Revisa tu conexión y vuelve a intentar.
            </p>
            <button
                type="button"
                onClick={onRetry}
                className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
            >
                Reintentar
            </button>
        </div>
    );
}
